import { useSettingStore } from '../../stores/setting';

import jQuery from 'jquery';
let $ = jQuery;

const Modal = {
	get visible_modals() {
		//Returns an array of modal objects that are visible
		return this.current_modals.filter((modal) => {
			return modal.options.presented;
		});
	},
	get hasVisibleModal() {
		return this.visible_modals.length > 0;
	},
};

Modal.Button = class Button {
	init() {
		this.styles = ['default'];
		this.style = 'general_modal_button_' + 'default';
		this.onclick = () => {};
		this.text = '';
		this.id = 'button' + Modal._chr4();
		this.uuid = 'button' + Modal._chr4();
		this.dismiss_modal_after_click = true;
		this.classList = 'general_modal_interactive_button inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm';
		this.destructive = false;
		this.style_options = {};
		this.attributes = '';
		this.primary_action_button = false;
	}
	constructor(text, on_click, options = {}, id) {
		this.init();
		if (on_click != undefined || null) {
			this.onclick = on_click;
		}
		if (text != undefined || null) {
			this.text = text;
		}
		if (id != undefined || null) {
			this.id = id;
		}
		if (options != undefined || null) {
			if (options.dismiss_modal_after_click != undefined || null) {
				this.dismiss_modal_after_click = options.dismiss_modal_after_click;
			}
			if (options.class_list != undefined || null) {
				for (const class_name of options.class_list) {
					this.classList += ` ${class_name}`;
				}
			}

			let attribute_elements = [];

			if (options.destructive != undefined || (null && options.destructive == true)) {
				this.destructive = options.destructive;
				attribute_elements.push('destructive');
			}
			if (options.inverted != undefined || (null && options.inverted == true)) {
				this.style_options.inverted = true;
				attribute_elements.push('inverted');
			} else {
				this.style_options.inverted = false;
			}
			if (options.border_inverted != undefined || (null && options['border-inverted'] == true)) {
				this.style_options.border_inverted = true;
				attribute_elements.push('border-inverted');
			} else {
				this.style_options.border_inverted = false;
			}
			if (options.border != undefined || (null && options.border == true)) {
				this.style_options.border = true;
				attribute_elements.push('border');
			} else {
				this.style_options.border = false;
			}
			if (options.center != undefined || (null && options.center == true)) {
				this.style_options.center = true;
				attribute_elements.push('center');
			} else {
				this.style_options.center = false;
			}
			if (options.bold != undefined || (null && options.bold == true)) {
				this.style_options.bold = true;
				attribute_elements.push('bold');
			} else {
				this.style_options.bold = false;
			}
			if (options.bigger != undefined || (null && options.bigger == true)) {
				this.style_options.bigger = true;
				attribute_elements.push('bigger');
			} else {
				this.style_options.bigger = false;
			}
			if (options.secondary != undefined || (null && options.secondary == true)) {
				attribute_elements.push('secondary');
			}
			if (options.primary_action_button === true) {
				this.primary_action_button = true;
			}
			this.attributes = attribute_elements.join(' ');
		}
	}
};

Modal.modal_shown = false;
Modal.current_modals = []; //Array of JS objects that contain the modal information EX: [{id: id, title: title, paragraph: paragraph}...];
Modal.top_most_modal = undefined; //Returns the top most visible modals object.
Modal.to_present_modals = []; //Array of Modal objects that need to be presented
Modal.present_animation_name = 'flipInX';
Modal.dismiss_animation_name = 'flipOutX';

// MARK: Creation Methods
Modal.createBasicDialog = function (title = '', paragraph = '', buttons = [], options = {}, on_dismiss_callback) {
	//Will return the modal's id;
	let id = options.id != undefined || null ? options.id : 'm' + this.generateID(); ////Add a 'm' due to css3 spec requiring a letter as the first character
	if (options.dismissible == undefined || null) {
		options.dismissible = true;
	}

	let options_to_advance = options;
	options_to_advance.presented = false;
	options_to_advance.on_dismiss = on_dismiss_callback;
	delete options_to_advance.id;

	let dialog = { id: id, title: title, paragraph: paragraph, interactive_html: options.interactive_html, buttons: buttons, options: options_to_advance };

	this.current_modals.push(dialog);
	this.__add_modal_html_to_DOM(id);

	if (options.present_immediately == false) {
		return id;
	}
	this.present(id);
	return id;
};
Modal.createInteractiveModal = function (title = '', paragraph = '', interactive_html = '', buttons = [], options = {}, on_dismiss_callback) {
	//Will return the modal's id; //TODO: Change from excepting html add some nice code;
	let id = options.id != undefined || null ? options.id : 'm' + this.generateID(); //Add a 'm' due to css3 spec requiring a letter as the first character
	if (options.dismissible == undefined || null) {
		options.dismissible = true;
	}

	let options_to_advance = options;
	options_to_advance.presented = false;
	options_to_advance.on_dismiss = on_dismiss_callback;
	delete options_to_advance.id;

	let dialog = { id: id, title: title, paragraph: paragraph, interactive_html: interactive_html, buttons: buttons, options: options_to_advance };

	this.current_modals.push(dialog);
	this.__add_modal_html_to_DOM(id);

	if (options.present_immediately == false) {
		return id;
	}
	this.present(id);
	document.dispatchEvent(
		new CustomEvent('interactiveModalCreated', {
			detail: { interactive_modal_id: id },
		})
	);
	useSettingStore().setInteractiveModalId(id);

	const primary_button = buttons.find((button) => button.primary_action_button === true);

	if (primary_button != undefined) {
		document.getElementById(primary_button.id).focus();
	}
	return id;
};

// MARK: Functions
Modal.__add_modal_html_to_DOM = function (modal_id) {
	let modal = this.getModalFromID(modal_id);
	if (modal == null || undefined) {
		console.warn("[Add Modal To DOM] Couldn't find modal with id of ", modal_id);
		return;
	}

	let modal_style = this.__getModalStyles(modal.options);

	let modal_html = '';

	modal_html += '<div id="' + modal.id + '" class="general_modal overlay backdrop-blur-md" style="display: none;">';

	modal_html += '<div id="' + modal.id + '_div" class="general_modal_div overlayInner animated fast ' + (!modal.options.dismissible ? 'hideCloseIcon' : '') + ' relative bg-zinc-700 text-zinc-50 px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-2xl w-full sm:p-6" style="' + modal_style + '">';

	modal_html += '<h1 style="margin:0px;" id="' + modal.id + '_title" class="general_modal_title text-lg leading-6 font-medium text-white">' + (modal.title || '') + '</h1>';

	modal_html += '<p style="margin: 5px 0;" id="' + modal.id + '_paragraph" class="general_modal_paragraph">' + (modal.paragraph || '') + '</p>';

	if (modal.interactive_html == undefined) {
		console.log('modal.interactive_html == undefined');
	} else {
		modal_html += '<div id="' + modal.id + '_interactive_div" class="general_modal_interactive_div" style="' + modal.options.interactive_div_styles + '" ' + (modal.options.interactive_div_vertical ? 'vertical' : '') + '>';
		modal_html += modal.interactive_html;
		modal_html += '</div>';
	}

	modal_html += '<div id="' + modal.id + '_buttons_div_container" class="general_modal_buttons_div_container">';
	modal_html += '<div id="' + modal.id + '_buttons_div" class="general_modal_buttons_div mt-5 sm:mt-6 mb-6 sm:mb-0 flex flex-col sm:flex-row items-between sm:justify-between space-y-2 sm:space-x-2 sm:space-y-0" style="' + modal.options.buttons_div_styles + '">';
	for (let i = 0; i < modal.buttons.length; i++) {
		let button = modal.buttons[i];
		let button_html = `<button id='${button.id}' modal-id='${modal.id}' uuid='${button.uuid}' class='${button.classList}'  ${button.attributes} onclick='Modal.buttonClicked(this);'>${button.text}</button>`;
		modal_html += button_html;
	}
	modal_html += '</div>';
	modal_html += '</div>';

	modal_html += '</div>';

	modal_html += '</div>';

	document.querySelector('#general_modals').innerHTML += modal_html;

	if (modal.options.on_creation != undefined || null) {
		modal.options.on_creation();
	}
};

Modal.buttonClicked = function (element) {
	console.log('UUID: ', element.getAttribute('uuid'));
	let button_uuid = element.getAttribute('uuid');
	let modal = this.getModalFromID(element.getAttribute('modal-id'));
	if (modal == null || modal == undefined) {
		console.warn("[Add Modal To DOM] Couldn't find modal with id of ", modal);
		return;
	}
	for (let i = 0; i < modal.buttons.length; i++) {
		let button = modal.buttons[i];
		if (button.uuid == button_uuid) {
			button.onclick();
			console.log('modal_id', modal.id);
			if (button.dismiss_modal_after_click) {
				Modal.dismiss(modal.id);
			}
		}
	}
};

Modal.present = function (modal_id, force_present_on_top = false) {
	let modal = this.getModalFromID(modal_id);
	let modal_index = this.getModalIndexFromID(modal_id);
	if (modal == null || undefined) {
		console.warn("[Present Modal] Couldn't find modal with id of ", modal_id);
		return;
	}

	if (!force_present_on_top && this.visible_modals.length != 0) {
		//A modal is already present, wait to present this one
		this.to_present_modals.push(modal);
		return;
	}

	$('#' + modal.id).fadeIn(200);
	document.querySelector(`#${modal.id} .general_modal_div`).classList.add(this.present_animation_name);
	$('#bodyContainer').addClass('blur');
	this.current_modals[modal_index].options.presented = true;
	this.top_most_modal = modal;

	$('html').css('overflow', 'hidden');
	window.scrollTo(0, 0);

	if (typeof registerListenerForInputFocusAndBlur === 'function') {
		// registerListenerForInputFocusAndBlur();
		console.log('registerListenerForInputFocusAndBlur');
	} //Add listeners to any inputs in the general modal
	if (typeof windowManager === 'object') {
		// windowManager.openedWindow('modal_' + modal.id);
		console.log('windowManagerNotFound');
	}

	if (modal.options.dismissible) {
		$('#' + modal.id).off('mouseup');
		$('#' + modal.id).mouseup(function (e) {
			var container = $('#' + modal.id + '_div');
			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				Modal.dismiss(modal.id);
			}
		});
	} else {
		$('#' + modal.id).off('mouseup');
		$('#' + modal.id).mouseup(function (e) {
			// var container = $('#' + modal.id + '_div');

			console.log('target', e.target, e);
			// if the target of the click isn't the container nor a descendant of the container
			// if (!container.is(e.target) && container.has(e.target).length === 0) {
			//      Modal.dismiss(modal.id);
			// }
		});
	}

	if (modal.options.on_present != undefined || null) {
		modal.options.on_present();
	}
};

Modal.dismiss = function (modal_id) {
	let modal = this.getModalFromID(modal_id);
	let modal_index = this.getModalIndexFromID(modal_id);
	if (modal == null || undefined) {
		console.warn("[Dismiss Modal] Couldn't find modal with id of ", modal_id);
		return;
	}

	$('#bodyContainer').removeClass('blur');
	$('#' + modal.id).fadeOut(200);
	document.querySelector(`#${modal.id} .general_modal_div`).classList.add(this.dismiss_animation_name);
	$('#' + modal.id).off('mouseup');

	$('html').css('overflow', 'auto');
	window.scrollTo(0, 0);

	this.current_modals[modal_index].options.presented = false;
	this.top_most_modal = undefined;

	if (typeof registerListenerForInputFocusAndBlur === 'function') {
		// registerListenerForInputFocusAndBlur();
		console.log('registerListenerForInputFocusAndBlur');
	} //Remove listeners from any inputs in the general modal;
	if (typeof windowManager === 'object') {
		// windowManager.closedWindow('modal_' + modal.id);
		console.log('windowManagerNotFound');
	}

	if (modal.options.on_dismiss != undefined || null) {
		modal.options.on_dismiss(modal.id);
	}

	if (modal.options.destroy_on_dismissal != undefined && modal.options.destroy_on_dismissal == true) {
		this.destroy(modal.id);
	}

	if (this.to_present_modals.length != 0) {
		//Present another modal
		this.present(this.to_present_modals[0].id);
		this.to_present_modals.splice(0, 1); //Delete the first modal in the array.
	}
	document.dispatchEvent(new CustomEvent('interactiveModalDismissed'));
};

Modal.destroy = function (modal_id) {
	let modal = this.getModalFromID(modal_id);
	let modal_index = this.getModalIndexFromID(modal_id);
	if (modal == null || undefined) {
		console.warn("[Destroy Modal] Couldn't find modal with id of ", modal_id);
		return;
	}

	if (modal.options.presented == true) {
		this.dismiss(modal_id);
	}

	$('#' + modal.id).remove();
	this.current_modals.splice(modal_index, 1); //Delete it
};

Modal.getModalFromID = function (id) {
	for (let i = 0; i < this.current_modals.length; i++) {
		if (this.current_modals[i].id == id) {
			return this.current_modals[i];
		}
	}
	return null;
};

Modal.getModalIndexFromID = function (id) {
	for (let i = 0; i < this.current_modals.length; i++) {
		if (this.current_modals[i].id == id) {
			return i;
		}
	}
	return null;
};

Modal.__getModalStyles = function (options) {
	let width_option = options.width;
	if (width_option != undefined) {
		if (typeof width_option == 'number') {
			width_option = width_option + 'px';
		}
	}
	let height_option = options.height;
	if (height_option != undefined) {
		if (typeof height_option == 'number') {
			height_option = height_option + 'px';
		}
	}
	let min_width_option = options.min_width;
	if (min_width_option != undefined) {
		if (typeof min_width_option == 'number') {
			min_width_option = min_width_option + 'px';
		}
	}
	let min_height_option = options.min_height;
	if (min_height_option != undefined) {
		if (typeof min_height_option == 'number') {
			min_height_option = min_height_option + 'px';
		}
	}
	let max_width_option = options.max_width;
	if (max_width_option != undefined) {
		if (typeof max_width_option == 'number') {
			max_width_option = max_width_option + 'px';
		}
	}
	let max_height_option = options.max_height;
	if (max_height_option != undefined) {
		if (typeof max_height_option == 'number') {
			max_height_option = max_height_option + 'px';
		}
	}
	let padding_bottom_option = options.padding_bottom;
	if (padding_bottom_option != undefined) {
		if (typeof padding_bottom_option == 'number') {
			padding_bottom_option = padding_bottom_option + 'px';
		}
	}

	return (
		(width_option ? 'width:' + width_option + ';' : '') +
		(height_option ? 'height:' + height_option + ';' : '') +
		(min_width_option ? 'min-width:' + min_width_option + ';' : '') +
		(min_height_option ? 'min-height:' + min_height_option + ';' : '') +
		(max_width_option ? 'max-width:' + max_width_option + ';' : '') +
		(max_height_option ? 'max-height:' + max_height_option + ';' : '') +
		(padding_bottom_option ? 'padding-bottom:' + padding_bottom_option + ';' : '')
	);
};

Modal._chr4 = function chr4() {
	return Math.random().toString(16).slice(-4);
};

Modal.generateID = function () {
	return Modal._chr4() + Modal._chr4() + Modal._chr4() + Modal._chr4();
};

export default Modal;
